import { useParams } from 'react-router-dom'

import { useAppealDetailsForMyOrders } from 'entities/tour/hooks'
import { TourDetail } from 'entities/tour/ui/tour-detail'

import { useMyOrderDetailsHeaderMeta } from './model/use-my-order-details-header-meta'

const MyOrdersDetailsPage = () => {
  const { appealId } = useParams<{ appealId: string }>()
  const { appealDetails, isLoading } = useAppealDetailsForMyOrders(appealId)
  const { title, subtitle } = useMyOrderDetailsHeaderMeta(appealDetails)

  return (
    <TourDetail
      isError={!appealDetails && !isLoading}
      isLoading={isLoading}
      hotelDetail={appealDetails?.hotel ?? null}
      isViewMode
      title={title}
      subtitle={subtitle}
    />
  )
}

export default MyOrdersDetailsPage
